// Bepaalt welke onboarding-stappen relevant zijn voor de gegeven module-keuze.
//
//   - Step 3 (sector/standaard-keuze) verschijnt alleen wanneer `impactMeten`
//     actief is EN er geen partner-deeplink is. Bij partner is de TOC al
//     gedefinieerd door de partner-tenant — sector-keuze is dan moot.
//   - Step 4 (modules-picker) wordt geskipt bij een partner-deeplink. De
//     partner dicteert het pakket (fixedPackage + freeIncludedModules), dus
//     de gebruiker heeft niets te kiezen.
//   - Stap 6 is verwijderd uit de sequence (april 2026) — de "Naar betalen"-
//     knop op Stap 5 start direct de Stripe-checkout-redirect. Stap 6's
//     component-bestand blijft staan voor eventueel handmatige nav naar
//     /signup/6, maar de flow gaat er niet meer langs.
//   - Alle flows eindigen op de success-pagina (stap 7) — daar gaat de
//     gebruiker rechtstreeks vanuit de "Naar mijn omgeving"-knop naar het
//     dashboard.
//
// Output: array van genummerde step-IDs in volgorde.

const getStepSequence = ({ activeModules = {}, partnerSlug = null } = {}) => {

    const hasImpactMeten = activeModules.impactMeten === true
    const hasPartner = !!partnerSlug

    const sequence = [1, 2]
    if (hasImpactMeten && !hasPartner) sequence.push(3)
    if (!hasPartner) sequence.push(4)
    sequence.push(5, 7)

    return sequence

}

export default getStepSequence
